<template lang="pug">
  .container-players#players
    .line-top-container
    .container
      .title-players-red PARTICIPANTES
      .info-text
        .info-small Total de participantes en el mes de {{ getSelected }}
        .info-block {{ players.data.total }}
      .tabs
        ul
          li(@click="setOption(month.id)"
            :class="{ 'is-active' : month.status }"
            :key="month.id"
            v-for="(month, index) in months")
              a {{ month.name }}
      .base-players(v-if="players.data.total != 0")
        .overflow-player.fade-in
          .players
            .player(v-for="(player, index) in players.data.data" :key="index")
              span.name {{ player.nombre }}
              .data-attr
                span
                  b Matrícula
                  span {{ player.matricula }}
                span
                  b NIT
                  span {{ player.identificacion }}
                span
                  b Fecha de Renovación
                  span {{ $root.formatDate(player.fecharenovacion) }}
        .content-paginate.is-centered.pagination
          pagination.pagination-list(:limit='1', :show-disabled="false", :data="players.data", @pagination-change-page="getPlayers")
            span(slot="prev-nav") &lt
            span(slot="next-nav") &gt
      .empty-players(v-else)
        .fade-in
          span {{ emptyPlayersText }}
          .progress-countdown(v-if="countdown.status")
            .airplane-progress
              span.progress-text {{ countdown.percent }} %
              .progress-date(:style="{ 'height': 'calc(100% - ' + countdown.percent + '%)' }")
                .content-wave
                  .gire
                    svg(version='1.1', xmlns='https://www.w3.org/2000/svg', xmlns:xlink='https://www.w3.org/1999/xlink', x='0px', y='0px', style='display: none')
                      symbol#wave
                        path(d='M420,20c21.5-0.4,38.8-2.5,51.1-4.5c13.4-2.2,26.5-5.2,27.3-5.4C514,6.5,518,4.7,528.5,2.7c7.1-1.3,17.9-2.8,31.5-2.7c0,0,0,0,0,0v20H420z')
                        path(d='M420,20c-21.5-0.4-38.8-2.5-51.1-4.5c-13.4-2.2-26.5-5.2-27.3-5.4C326,6.5,322,4.7,311.5,2.7C304.3,1.4,293.6-0.1,280,0c0,0,0,0,0,0v20H420z')
                        path(d='M140,20c21.5-0.4,38.8-2.5,51.1-4.5c13.4-2.2,26.5-5.2,27.3-5.4C234,6.5,238,4.7,248.5,2.7c7.1-1.3,17.9-2.8,31.5-2.7c0,0,0,0,0,0v20H140z')
                        path(d='M140,20c-21.5-0.4-38.8-2.5-51.1-4.5c-13.4-2.2-26.5-5.2-27.3-5.4C46,6.5,42,4.7,31.5,2.7C24.3,1.4,13.6-0.1,0,0c0,0,0,0,0,0l0,20H140z')
                    svg.wave-back(viewBox='0 0 560 20')
                      use(xlink:href='#wave')
                    svg.wave-front(viewBox='0 0 560 20')
                      use(xlink:href='#wave')
            .countdown
              .months(:title="countdown.months == 1 ? 'Mes' : 'Meses'") {{ countdown.months }}
              .days(:title="countdown.days == 1 ? 'Día' : 'Días'") {{ countdown.days }}
              .hours(:title="countdown.hours == 1 ? 'Hora' : 'Horas'") {{ countdown.hours }}
              .minutes(:title="countdown.minutes == 1 ? 'Minuto' : 'Minutos'") {{ countdown.minutes }}
              .seconds(:title="countdown.seconds == 1 ? 'Segundo' : 'Segundos'") {{ countdown.seconds }}
    img.beach-img(src="/images/curvas-03-01-2020.png")
</template>

<script>

Vue.component('pagination', require('laravel-vue-pagination'))

require('moment-countdown')

export default {
  data() {
     return {
       players: {
         data: {
           data: []
         }
       },
       months: [
         { id: 0, name: 'Enero', status: true },
         { id: 1, name: 'Febrero', status: false },
         { id: 2, name: 'Marzo', status: false },
       ],
       actual_tab_id: -1,
       actual_code: '',
       month_selected_by_user: '',
       format_date_countdown: '',
       params: {},
       countdown: {
         months: 0,
         days: 0,
         hours: 0,
         minutes: 0,
         seconds: 0,
         status: true,
         percent: 0
       }
     }
  },
  computed: {
    getSelected(){
      for (var i = 0; i < this.months.length; i++) {
        if(this.months[i].status){
          return this.months[i].name
        }
      }
      return "Enero"
    },
    getCurrentConcurseCode() {
      this.caseSelector(moment().month())
    },
    emptyPlayersText() {
      let vm = this
      if (vm.$root.sending)
        return 'Cargando...'
      else
        return `No hay concursantes para el mes de ${vm.month_selected_by_user} aún.`
    }
  },
  methods: {
    getPlayers(page = 1) {
      let vm = this
      vm.$root.sending = !vm.$root.sending
      axios.get(`https://control.ccmonteria.org.co/api/concursos/${vm.actual_code}/findConcursantes?page=${page}`)
      .then(function (response) {
        const r = response.data
        vm.players = r
        if (r.data.total == 0)
          vm.calculeDaysLeft()
        vm.$root.sending = !vm.$root.sending
      })
      .catch(function (error) {
        console.log(error)
        vm.$root.sending = !vm.$root.sending
      })
    },
    resetStatusTabs() {
      let vm = this
      _.forEach(vm.months, function(m) {
        m.status = false
      })
    },
    getParamsUrl() {
      let vm = this
      let uri = window.location.href.split('?')
      if (uri.length == 2)
      {
        let vars = uri[1].split('&')
        let getVars = {}
        let tmp = ''
        _.forEach(vars, function (v) {
          tmp = v.split('=')
          if(tmp.length == 2)
          getVars[tmp[0]] = tmp[1]
        })
        vm.params = getVars
      }
      vm.getPlayersByParams()
    },
    getPlayersByParams() {
      let vm = this
      if (vm.params.tab) {
        switch (vm.params.tab) {
          case 'enero':
            vm.setOption(0)
            break
          case 'febrero':
            vm.setOption(1)
            break
          case 'marzo':
            vm.setOption(2)
            break
          default:
            vm.setOption(-1)
            break

        }
      } else {
        vm.setOption(0)
      }
    },
    updateHistory(id) {
      let vm = this
      let searchParams = new URLSearchParams(window.location.search)
      searchParams.set("tab", id)
      let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString()
      history.pushState(null, '', newRelativePathQuery)
    },
    setOption(o) {
      let vm = this
      if (o != vm.actual_tab_id) {
        const f = _.find(vm.months, function (m) {
          return m.id == o
        })
        vm.resetStatusTabs()
        f.status = true
        vm.actual_tab_id = o
        clearInterval(window.timeLeftInterval)
        vm.caseSelector(o)
        vm.updateHistory(vm.month_selected_by_user)
        vm.getPlayers()
      }
    },
    caseSelector(o) {
      let vm = this
      switch (o) {
        case 0:
          vm.actual_code = 'REN_GAN_ENERO_2020'
          vm.month_selected_by_user = 'enero'
          vm.format_date_countdown = '2020-01-01'
          break
        case 1:
          vm.actual_code = 'REN_GAN_FEBRERO_2020'
          vm.month_selected_by_user = 'febrero'
          vm.format_date_countdown = '2020-02-01'
          break
        case 2:
          vm.actual_code = 'REN_GAN_MARZO_2020'
          vm.month_selected_by_user = 'marzo'
          vm.format_date_countdown = '2020-03-01'
          break
        default:
          vm.actual_code = 'CODE_NOT_ASSIGNED'
          vm.month_selected_by_user = ''
          break
      }
    },
    calculeDaysLeft() {
      let vm = this
      let datediff =  moment(vm.format_date_countdown).countdown()
      if (datediff.start >  datediff.end) {
        vm.getActualTimeLeft()
        vm.countdown.status = true
        //vm.daysLeft = `Solo falta ${moment(vm.format_date_countdown).countdown().toString()} para iniciar este mes.`
        window.timeLeftInterval = setInterval(function() {
          vm.getActualTimeLeft()
        }, 1000)
      } else {
        vm.countdown.status = false
      }
    },
    getActualTimeLeft() {
      let vm = this
      vm.countdown.months = moment(vm.format_date_countdown).countdown().months
      vm.countdown.days = moment(vm.format_date_countdown).countdown().days
      vm.countdown.hours = moment(vm.format_date_countdown).countdown().hours
      vm.countdown.minutes = moment(vm.format_date_countdown).countdown().minutes
      vm.countdown.seconds = moment(vm.format_date_countdown).countdown().seconds

      var start = moment(`2020-0${(moment().month() + 1)}-01`).unix()
      let end = moment(vm.format_date_countdown).unix()
      var now = moment().unix()


      let p = setInterval(function () {        
        if (vm.countdown.percent == Math.round(( ( now - start ) / ( end - start ) ) * 100))
          clearInterval(p)
        else {
          if (vm.countdown.percent > Math.round(( ( now - start ) / ( end - start ) ) * 100)) {
            vm.countdown.percent--
          } else {
            vm.countdown.percent++
          }
        }
      }, 100)
    }
  },
  mounted() {
    let vm = this
    vm.getParamsUrl()
  }
}
</script>

<style lang="sass">
  .content-wave
    position: absolute
    bottom: -2px
    width: 200px
    -webkit-transform: translateX(-50%)
    transform: translateX(-50%)
    left: 50%
    height: 5px
    overflow: hidden
    & .gire
      transform: rotate(180deg) translate(0, 100%)
      position: absolute
      z-index: 2
      width: 100%
      height: 100%
      background: transparent
      transition: all .3s ease
      left: 0
      top: 4px

  .wave-back, .wave-front
    width: 100%
    position: absolute
    bottom: 0
    top: 0
    height: inherit

  .wave-back
    right: 0
    fill: #fff
    animation: waveBack 1.4s infinite linear

  .wave-front
    left: 0
    fill: #fff
    animation: waveFront .7s infinite linear

  .airplane-progress
    background: url(../../../images/assets2020/airplane.svg)
    background-repeat: no-repeat
    background-position: 50% 88%
    background-size: 310px
    height: 170px
    margin-bottom: 20px
    position: relative
    display: flex
    justify-content: center
    align-items: center
    color: #ec594f
    font-size: 50px
    font-weight: bold
    & .progress-text
      z-index: 1
    & .progress-date
      position: absolute
      width: 100%
      height: 0%
      background: #fff
      top: 0
      left: 0
  .capitalize
    text-transform: capitalize
    font-weight: bold
  .tabs, .empty-players
    padding: 0 20px
    & ul
      justify-content: center

  .empty-players
    text-align: center
    font-size: 18px
    & span
      margin-bottom: 10px
      display: block

  .countdown
    display: flex
    justify-content: space-around
    width: 350px
    margin: auto
    position: relative
    & div
      width: 40px
      height: 40px
      display: flex
      align-items: center
      justify-content: center
      border: 1px solid #ec594f
      color: #ec594f
      border-radius: 5px
      &:after
        content: attr(title)
        position: absolute
        bottom: -28px
        font-size: 14px

  .content-paginate
    padding: 20px
  .overflow-player
    max-height: 565px
    overflow: auto
    padding: 0 20px

  .info-text
    max-width: 600px
    margin: auto
    text-align: center
    background: radial-gradient(circle farthest-corner at 200px 0,#6971b1, #555b8e)
    -webkit-background-clip: text
    -webkit-text-fill-color: transparent
    margin-bottom: .8em
    .info-block
      font-family: "Montserrat-BlackItalic"
      font-size: 1.9rem
    .info-small
      font-family: "Montserrat-MediumItalic"
      font-size: 1.3rem
  .container-players
    background: #fff
    position: relative
    //transform: translateY(-120px) skewY(5deg)
    //border-top: 10px solid #FFB216
    //border-bottom: 10px solid #FFB216
    //padding: 6em 20px
    //padding-bottom: 14em
    z-index: 1
    &:after, &:before
      width: 220px
      height: 220px
      position: absolute
      background-size: cover !important
      background-repeat: no-repeat !important
      background-position: center !important
      opacity: .2
      z-index: -1
    &:after
      content: ''
      //background: url(../../../images/points_triangle.svg)
      top: 0
      left: 0

    &:before
      content: ''
      //background: url(../../../images/points_triangle.svg)
      bottom: -68px
      right: -50px
      transform: rotate(137deg)
  .tabs ul
    border: none!important
    li
      position: relative
    a 
      font-family: "Montserrat-Regular"
      color: #9e9e9e!important
    .is-active
      a
        color: #505050!important
      &:after
        content: ''
        position: absolute
        bottom: 0
        left: 0
        z-index: -1
        height: 1px
        width: 100%
        background: linear-gradient(to right, #e98523, #ee3078)
  .player
    border: 1px solid rgba(95, 102, 156, 0.48)
    border-radius: 20px
    color: purple
    margin-bottom: 15px
    width: 100%
    & .data-attr
      padding: 2px 0
      display: flex
      justify-content: space-around
      align-items: center
      & span
        font-size: 13px
        font-family: "Montserrat-Light"
        background: radial-gradient(circle farthest-corner at 200px 0,#6971b1,#555b8e)
        -webkit-background-clip: text
        -webkit-text-fill-color: transparent
    & span
      padding: 5px 10px
      &.name
        font-family: "Montserrat-LightItalic"
        letter-spacing: 2px
        display: -webkit-box
        -webkit-font-smoothing: antialiased
        -webkit-line-clamp: 1
        -webkit-box-orient: vertical
        overflow: hidden
        border-top-right-radius: 20px
        border-top-left-radius: 20px
        border-bottom: 1px solid
        text-align: center
        font-weight: bold
        background: radial-gradient(circle farthest-corner at 200px 0, #6971b1, #555b8e)
        color: #fff
        font-size: 1.5rem
  .title-players-red
    margin-top: 10px
    letter-spacing: 3px
    font-family: "Montserrat-Black"
    background: linear-gradient(to bottom, #e98523 , #ee3078)
    -webkit-background-clip: text
    -webkit-text-fill-color: transparent
    text-align: center
    margin-bottom: 0
    font-size: 3rem
    font-weight: bold

  .page-item
    &.active
      & .page-link
        background-color: #5F669C
        border-color: #5F669C
        color: #fff

  .page-link
    border: 1px solid #dbdbdb
    color: #363636
    min-width: 2.25em
    padding-left: 0.5em
    padding-right: 0.5em
    margin: 0.25rem
    text-align: center
    align-items: center
    border-radius: 4px
    box-shadow: none
    display: inline-flex
    font-size: 1rem
    height: 2.25em
    justify-content: center
    line-height: 1.5
  .beach-img
    width: 100%
    position: relative
    top: -30px
  .line-top-container
    position: relative
    width: 90%
    height: 1px
    margin-left: 5%
    background: #9e9e9e
  .base-players
    margin: 0px 20px
</style>



// WEBPACK FOOTER //
// resources/js/components/PageConcurso2020/PlayerConcurse.vue